import React from 'react';
import { useTranslation } from '@/lib/i18n';

export const TypingIndicator: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="r3c-typing">
      <div className="r3c-typing__indicator">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="r3c-typing__text">{t('chat.typing')}</div>
    </div>
  );
};
